import { unref, watch, watchEffect, type MaybeRef } from "vue";
import { Api, type RequestParams } from "../api-models";
import { getToken, useCustomerIdRef } from "./auth";

const httpClient = new Api<{ useAuth?: boolean }>({
	baseApiParams: {
		secure: true,
		headers: useCustomerIdRef().value
			? { "X-Organization-Id": useCustomerIdRef().value }
			: {},
	},
	securityWorker: async params => {
		if (!params?.useAuth) return {};

		const headers: Record<string, string> = {
			Authorization: `Bearer ${await getToken()}`,
		};
		return { headers };
	},
});

watch(
	useCustomerIdRef(),
	accountId => {
		if (!accountId) return;
		(
			httpClient as unknown as { baseApiParams: RequestParams }
		).baseApiParams.headers = {
			"X-Organization-Id": accountId ?? "",
		};
	},
	{ immediate: true },
);

export const initClient = (
	isLocal: boolean,
	machineIP: string,
	fpPort: string,
	defaultUrl: string,
) => {
	httpClient.baseUrl = isLocal
		? `http://${machineIP}:${fpPort}/api-v2`
		: defaultUrl;
	httpClient.setSecurityData({
		useAuth: !isLocal,
	});
};

export const initClientReactive = (
	baseUrl: MaybeRef<string>,
	useAuth: MaybeRef<boolean>,
) => {
	watchEffect(() => {
		httpClient.baseUrl = unref(baseUrl);
		httpClient.setSecurityData({
			useAuth: unref(useAuth),
		});
	});
};

export const useHttp = (): Api<unknown> => httpClient as Api<unknown>;
